import axios from 'axios'

const state = {
    setMainCategories: null,
    setMainSubCategories: null,
}

const getters = {
    setMainCategories (state) {
        return state.setMainCategories
    },
    setMainSubCategories (state) {
        return state.setMainSubCategories
    },
    // console.log(Object.assign({}, activeUser)) 
}

const actions = {
    // add new category
    async addCategoryAction({ dispatch }, categoryObj) {
        let response = await axios.post('/manage-categories/save-category', categoryObj)
        if(response && !response.data.error){
            dispatch('fetchMainCategoriesAction') 
        }
        return response.data
    },
    
    // add new sub-category
    async addSubCategoryAction({ dispatch }, subCategoryObj) {
        let response = await axios.post('/manage-categories/save-sub-category', subCategoryObj)
        if(!response.data.error){
            dispatch('fetchSubCategoriesAction', subCategoryObj) 
        }
        return response.data
    },

    // fetch main categories
    async fetchMainCategoriesAction({ commit, dispatch }) {
        let response = await axios.get(`/manage-categories/main-categories`)
        commit('SET_MAIN_CATEGORIES', null)
        if(!response.data.error){
            commit('SET_MAIN_CATEGORIES', response.data.result) 
            dispatch('fetchCategories') // for general shoppers display
        }
        return response.data
    },
    
    // fetch sub categories
    async fetchSubCategoriesAction({ commit }, subCategoryObj) {
        let response = await axios.get(`/manage-categories/sub-category/${subCategoryObj.categoryName}`)
        commit('SET_MAIN_SUB_CATEGORIES', null)
        if(!response.data.error){
            return commit('SET_MAIN_SUB_CATEGORIES', response.data.result) 
        }
        return response.data
    },
    
    // delete main category
    async deleteCategoryAction({ dispatch }, categoryObj) {
        let response = await axios.post('/manage-categories/delete-main-category', categoryObj)
        if(!response.data.error){
            dispatch('fetchMainCategoriesAction') 
        }
        return response.data
    },
    
    // delete sub category
    async deleteSubCategoryAction({ dispatch }, subCategoryObj) {
        let response = await axios.post('/manage-categories/delete-sub-category', subCategoryObj)
        if(!response.data.error){
            dispatch('fetchSubCategoriesAction', subCategoryObj) 
        }
        return response.data
    },

    // add new sub-category shipping fee
    async addShippingFeeAction({ dispatch }, subCategoryFeeObj) {
        let response = await axios.post('/manage-categories/sub-category-shipping-fees', subCategoryFeeObj)
        if(!response.data.error){
            dispatch('fetchSubCategoriesAction', subCategoryFeeObj) 
        }
        return response.data
    },

}

const mutations = {
    SET_MAIN_CATEGORIES: (state, setMainCategories) => (state.setMainCategories = setMainCategories),
    SET_MAIN_SUB_CATEGORIES: (state, setMainSubCategories) => (state.setMainSubCategories = setMainSubCategories),
}

export default {
    state,
    getters,
    actions,
    mutations
}